<div
  class="table-responsive table-overflow ps-table"
  [ngClass]="{ 'ps-table-overflow': overflowed$ | async }"
  infiniteScroll
  [infiniteScrollDistance]="scroll.distance"
  [infiniteScrollThrottle]="scroll.throttle"
  (scrolled)="onScroll()"
>
  <button
    *ngIf="scrollLeft$ | async"
    class="ps-table-scroll-left scroll-button"
    psUiLongPress
    type="button"
    (click)="onScrollLeft()"
    (longPress)="onScrollLeft()"
  >
    <i class="fa fa-caret-left fa-3x scroll-button" aria-hidden="true"> </i>
  </button>
  <div class="table-container" #tableContainer>
    <table class="table">
      <thead *ngIf="!headless">
        <ng-container *ngIf="state$ | async as state">
          <tr>
            <th
              class="checkbox table-stick-column"
              *ngIf="checkbox && checkbox.show$ | async"
            >
              <label *ngIf="checkbox!.showSelectAll" class="checkbox-all">
                <input
                  type="checkbox"
                  [checked]="allSelected"
                  (change)="onSelectAll($event)"
                  [disabled]="checkbox!.disable"
                />
              </label>
            </th>
            <ng-container *ngFor="let column of columns">
              <th
                *ngIf="column.show$ | async"
                [ngStyle]="{ width: column.space() }"
              >
                <ng-container
                  *ngIf="column.header"
                  [ngTemplateOutlet]="column.header.template"
                ></ng-container>
                <ps-ui-table-column-header
                  *ngIf="!column.header"
                  [title]="column.title"
                  [items]="(column.filters$ | async) || []"
                  [groups]="(column.groups$ | async) || {}"
                  [field]="column.field"
                  [multi]="column.multi"
                  [searchDropdownItems]="column.searchDropdownItems"
                  [showClearStateButton]="column.showClearStateButton"
                  [filterable]="(column.filterable$ | async) || false"
                  [searchable]="column.searchable"
                  [sortable]="column.sortable"
                  [sorted]="state.sorted(column.field)"
                  [filtered]="state.filtered(column.field)"
                  [delegate]="column.delegate"
                  [searchType]="column.searchType"
                  (sort)="onStateChange($event)"
                  (filter)="onStateChange($event)"
                ></ps-ui-table-column-header>
              </th>
            </ng-container>
          </tr>
        </ng-container>
      </thead>
      <tbody>
        <ng-container
          *ngFor="
            let element of elements$ | async;
            index as i;
            trackBy: trackByProperty
          "
        >
          <tr [ngClass]="{ selected: element.selected }">
            <ng-container>
              <td
                class="checkbox table-stick-column table-border-{{ border }}"
                *ngIf="checkbox && checkbox.show$ | async"
              >
                <label>
                  <input
                    type="checkbox"
                    [checked]="element.selected"
                    (change)="onElementSelected(element)"
                    [disabled]="checkbox!.disable"
                  />
                </label>
              </td>
            </ng-container>

            <ng-container *ngFor="let column of columns">
              <td
                *ngIf="column.show$ | async"
                class="table-border-{{ border }}"
                [ngStyle]="{ width: column.space() }"
                (click)="column.content.tap.emit(element.data)"
              >
                <ng-container
                  [ngTemplateOutlet]="column.template"
                  [ngTemplateOutletContext]="{
                    $implicit: element.data,
                    index: i
                  }"
                >
                </ng-container>
              </td>
            </ng-container>
          </tr>
          <ng-container *ngIf="expandable?.expanded$ | async as row">
            <tr class="no-highlight" *ngIf="row.expanded(i)">
              <td
                class="expandable-content"
                [attr.colspan]="columns.length + 1"
              >
                <ng-container
                  [ngTemplateOutlet]="expandable!.template"
                  [ngTemplateOutletContext]="{
                    $implicit: element.data,
                    index: i
                  }"
                >
                </ng-container>
              </td>
            </tr>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="footer">
          <tr>
            <td
              class="checkbox table-stick-column table-border-{{ border }}"
              *ngIf="checkbox && checkbox.show$ | async"
            ></td>
            <ng-container *ngFor="let column of columns; index as j">
              <td
                *ngIf="column.show$ | async"
                class="table-border-{{ border }}"
                [ngStyle]="{ width: column.space() }"
              >
                <ng-container
                  *ngIf="column.footer"
                  [ngTemplateOutlet]="column.footer.template"
                  [ngTemplateOutletContext]="{
                    $implicit: column,
                    index: j
                  }"
                >
                </ng-container>
              </td>
            </ng-container>
          </tr>
        </ng-container>
      </tbody>
      <ng-container *ngIf="caption">
        <caption [ngStyle]="{ 'caption-side': caption.placement }">
          <ng-container [ngTemplateOutlet]="caption.template"></ng-container>
        </caption>
      </ng-container>
    </table>
  </div>
  <button
    *ngIf="scrollRight$ | async"
    type="button"
    psUiLongPress
    (click)="onScrollRight()"
    (longPress)="onScrollRight()"
    class="ps-table-scroll-right scroll-button"
  >
    <i class="fa fa-caret-right fa-3x scroll-button" aria-hidden="true"> </i>
  </button>
</div>
